import { render, staticRenderFns } from "./SellingPricesEdit.vue?vue&type=template&id=5804fe99&"
import script from "./SellingPricesEdit.vue?vue&type=script&lang=js&"
export * from "./SellingPricesEdit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports